import { ShoppingCartOutlined } from "@ant-design/icons"
import { Col, Divider, Row, Tabs, Typography } from "antd"
import React, { useState } from "react"
import ActiveDesignerOrdersTable from "./ActiveDesignerOrdersTable"
import DesignerOrderTable from "./DesignerOrderTable"

const { Paragraph, Title } = Typography

export default function DesignerOrders() {
  const [activeKey, setActiveKey] = useState(1)

  const items = [
    {
      key: 1,
      label: `My Orders`,
      children: <ActiveDesignerOrdersTable activeKey={activeKey} />,
    },
    {
      key: 2,
      label: `Paper Manager`,
      children: <DesignerOrderTable activeKey={activeKey} />,
    },
    {
      key: 3,
      label: `Arsoma Orders`,
      children: <DesignerOrderTable activeKey={activeKey} />,
    },
    {
      key: 4,
      label: `Viva Orders`,
      children: <DesignerOrderTable activeKey={activeKey} />,
    },
    {
      key: 3.5,
      label: `Tape Orders`,
      children: <DesignerOrderTable activeKey={activeKey} />,
    },
    {
      key: 5,
      label: `Winder Orders`,
      children: <DesignerOrderTable activeKey={activeKey} />,
    },
    {
      key: 6,
      label: `Warehouse Orders`,
      children: <DesignerOrderTable activeKey={activeKey} />,
    },
    {
      key: 7,
      label: `Delivered Orders`,
      children: <DesignerOrderTable activeKey={activeKey} />,
    },
  ]

  const handleTabChange = (key) => {
    setActiveKey(key)
  }

  return (
    <div style={{ padding: 15 }}>
      <Row gutter={[15, 15]}>
        <Col span={24}>
          <Title level={3}>
            <ShoppingCartOutlined />
            <Divider type="vertical" />
            My Orders
          </Title>
        </Col>
        <Col span={24}>
          <Paragraph type="secondary">
            This is a orders section. Here you can view and filter all kinds of orders. Everything
            that is created/edited are being displayed here.
          </Paragraph>
        </Col>
      </Row>

      <Tabs defaultActiveKey={1} onChange={handleTabChange} items={items} />
    </div>
  )
}
